import { Box, Typography } from "@mui/material";

export const OnboardingProgressBar = ({
  completedCount,
  totalCount,
}: {
  completedCount: number;
  totalCount: number;
}) => {
  const size = 120;
  const strokeWidth = 6;
  const progress = (completedCount / totalCount) * 100;
  const gradientId = "progressGradient";
  const gradientShadowId = "progressShadowGradient";

  return (
    <Box>
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="15%" stopColor="#4bb6b7" />
              <stop offset="85%" stopColor="#198282" />
            </linearGradient>
            <radialGradient id={gradientShadowId}>
              <stop offset="40%" stopColor="#198282" />
              <stop offset="100%" stopColor="#198282" stopOpacity={0} />
            </radialGradient>
          </defs>

          {/* Background ring */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={(size - strokeWidth) / 2}
            fill="none"
            stroke={completedCount === 0 ? "#8E9598" : "#e0e0e0"}
            strokeWidth={strokeWidth}
            opacity={0.25}
          />

          {/* Progress ring */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={(size - strokeWidth) / 2}
            fill="none"
            stroke={`url(#${gradientId})`}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            strokeDasharray={`${2 * Math.PI * ((size - strokeWidth) / 2)}`}
            strokeDashoffset={`${
              2 * Math.PI * ((size - strokeWidth) / 2) * (1 - progress / 100)
            }`}
          />
        </svg>

        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            component="div"
            sx={{
              fontFamily: "AlbertSans",
              fontSize: "32px",
              fontWeight: 600,
              lineHeight: "24px",
              color: "#198282",
              display: "flex",
              alignItems: "baseline",
              gap: "4px",
            }}
          >
            {completedCount}
            <Typography
              component="span"
              sx={{
                fontSize: "20px",
                color: "#6B6E7B",
                fontWeight: "normal",
              }}
            >
              / {totalCount}
            </Typography>
          </Typography>
          <Typography variant="bodySmall">completed</Typography>
        </Box>
      </Box>
    </Box>
  );
};
